export default "__VITE_ASSET__C8B_xiM4__"